import moment from 'moment';
import Constants from '../utils/constants';
import BaseServiceCrud from './BaseServiceCrud';

export default class VoucherService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'voucher';
        this.getCodesCriteria = this.getCodesCriteria.bind(this);
        this.getCodes = this.getCodes.bind(this);
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            first_result: criteria.firstResult,
            date_from: criteria.dateFrom ? moment(criteria.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            date_to: criteria.dateTo ? moment(criteria.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            voucher_category: criteria.voucherCategoryName,
        });
    }

    getCodesCriteria(criteria) {
        return this.objToQueryString({
            first_result: criteria?.firstResult,
            max_results: criteria?.maxResults,
            sort_field: criteria?.sortField,
            sort_asc: criteria?.sortAsc,
        });
    }

    getCodes(voucherId, criteria) {
        const queryString = this.getCodesCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/codes/${voucherId}/${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    removeVoucher(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    
    publish(id) {
        return this.fetch(`${this.domain}/${this.path}/publish/${id}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
